<!-- SwipFx Orders Page (Bootstrap 5) -->
<!-- Tabs need bootstrap.bundle.js -->
<div class="min-vh-100 bg-light">
    <app-header [page]="'Admin'"></app-header>

    <main class="container py-4">
        <!-- Header -->
        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
            <div>
                <h4 class="mb-0 fw-bold">Orders</h4>
                <div class="text-muted small">Track all orders</div>
            </div>

            <form [formGroup]="searchForm" (ngSubmit)="submitSearch()">
                <div class="d-flex gap-2">
                    <button class="btn btn-outline-secondary btn-sm" [disabled]="loading" (click)="refresh()">
                        <span *ngIf="!loading">Refresh</span>
                        <span *ngIf="loading">Refreshing...</span>
                    </button>
                    <!-- placeholder only (you said you'll implement filters) -->
                    <div class="input-group input-group-sm" style="width: 240px;">
                        <input class="form-control" formControlName="searchQuery" placeholder="Order ID / Pair" />
                    </div>
                    <button type="submit" class="btn btn-outline-secondary btn-sm"
                        [class.active]="activeTab === 'tabSearch'" (click)="activeTab = 'tabSearch'">
                        Search
                    </button>

                    <button *ngIf="showSearchResult" class="btn btn-outline-danger btn-sm"
                        [class.active]="activeTab === 'tabAll'" (click)="activeTab = 'tabAll'">
                        Clear Search
                    </button>
                </div>
            </form>
        </div>

        <div class="row g-3">
            <!-- RIGHT: Tabs + table -->
            <div class="col-12 col-lg-12">
                <div class="card shadow-sm border-0">
                    <div class="card-body p-0">
                        <!-- Tabs -->
                        <ul class="nav nav-tabs px-3 pt-3" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabSearch'"
                                    [disabled]="!showSearchResult" (click)="activeTab = 'tabSearch'"
                                    data-bs-toggle="tab" data-bs-target="#tabSearch" role="tab">
                                    Search Result
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabAll'"
                                    (click)="activeTab = 'tabAll'" data-bs-toggle="tab" data-bs-target="#tabAll"
                                    type="button" role="tab">
                                    All
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabOpen'"
                                    (click)="activeTab = 'tabOpen'" data-bs-toggle="tab" data-bs-target="#tabOpen"
                                    type="button" role="tab">
                                    Open
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabPartial'"
                                    (click)="activeTab = 'tabPartial'" data-bs-toggle="tab" data-bs-target="#tabPartial"
                                    type="button" role="tab">
                                    Partial
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabCompleted'"
                                    (click)="activeTab = 'tabCompleted'" data-bs-toggle="tab"
                                    data-bs-target="#tabCompleted" type="button" role="tab">
                                    Completed
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabCancelled'"
                                    (click)="activeTab = 'tabCancelled'" data-bs-toggle="tab"
                                    data-bs-target="#tabCancelled" type="button" role="tab">
                                    Cancelled
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" type="button" [class.active]="activeTab === 'tabFailed'"
                                    (click)="activeTab = 'tabFailed'" data-bs-toggle="tab" data-bs-target="#tabFailed"
                                    type="button" role="tab">
                                    Failed
                                </button>
                            </li>
                        </ul>

                        <!-- Tab panes -->
                        <div class="tab-content p-3">

                            <!-- SEARCH -->
                            <div class="tab-pane fade" [class.show]="activeTab === 'tabSearch'"
                                [class.active]="activeTab === 'tabSearch'" id="tabSearch" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingSearchResults" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingSearchResults">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of searchResults">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount | smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount | smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }} {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="searchResults.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No search results</div>
                                                    <div class="small">Try a different search query.</div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <!-- ALL -->
                            <div class="tab-pane fade show active" [class.show]="activeTab === 'tabAll'"
                                [class.active]="activeTab === 'tabAll'" id="tabAll" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingAllOrders" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingAllOrders">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of allOrders">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount | smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount | smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }} {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="allOrders.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No orders yet</div>
                                                    <div class="small">Your orders will appear here.</div>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>

                                <app-pagination *ngIf="allOrdersMeta && allOrdersMeta.totalRows > 0" [url]='url'
                                    [counts]='allOrdersMeta!' (refresh)="getOrder(null, $event)"></app-pagination>

                                <!-- Footer -->
                                <!-- <div class="d-flex flex-wrap gap-2 justify-content-between align-items-center p-3 border-top">
                                    <div class="small text-muted">Showing 5 orders</div>
                                    <div class="d-flex gap-2">
                                        <button class="btn btn-outline-secondary btn-sm" disabled>Prev</button>
                                        <button class="btn btn-outline-secondary btn-sm">Next</button>
                                    </div>
                                </div> -->
                            </div>

                            <!-- OPEN -->
                            <div class="tab-pane fade" id="tabOpen" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingOpenOrders" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingOpenOrders">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of openOrders">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount | smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount | smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }} {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="openOrders.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No open orders yet</div>
                                                    <div class="small">Your open orders will appear here.</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <app-pagination *ngIf="openOrdersMeta && openOrdersMeta!.totalRows > 0" [url]='url'
                                    [counts]='openOrdersMeta' (refresh)="getOrder('Open', $event)"></app-pagination>
                            </div>

                            <!-- PARTIAL -->
                            <div class="tab-pane fade" id="tabPartial" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingPartialOrders" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingPartialOrders">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of partialOrders">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount | smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount | smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }} {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="partialOrders.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No partial orders yet</div>
                                                    <div class="small">Your partial orders will appear here.</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <app-pagination *ngIf="partialOrdersMeta && partialOrdersMeta.totalRows > 0" [url]='url'
                                    [counts]='partialOrdersMeta'
                                    (refresh)="getOrder('Partial', $event)"></app-pagination>
                            </div>

                            <!-- COMPLETED -->
                            <div class="tab-pane fade" id="tabCompleted" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingCompletedOrders" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingCompletedOrders">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of completedOrders">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount | smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount | smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }} {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="completedOrders.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No completed orders yet</div>
                                                    <div class="small">Your completed orders will appear here.</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <app-pagination *ngIf="completedOrdersMeta && completedOrdersMeta.totalRows > 0" [url]='url'
                                    [counts]='completedOrdersMeta'
                                    (refresh)="getOrder('Completed', $event)"></app-pagination>
                            </div>

                            <!-- CANCELLED -->
                            <div class="tab-pane fade" id="tabCancelled" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingCancelledOrders" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingCancelledOrders">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of cancelledOrders">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount | smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount | smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }} {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="cancelledOrders.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No cancelled orders yet</div>
                                                    <div class="small">Your cancelled orders will appear here.</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <app-pagination *ngIf="cancelledOrdersMeta && cancelledOrdersMeta.totalRows > 0" [url]='url'
                                    [counts]='cancelledOrdersMeta'
                                    (refresh)="getOrder('Cancelled', $event)"></app-pagination>
                            </div>

                            <!-- FAILED -->
                            <div class="tab-pane fade" id="tabFailed" role="tabpanel">
                                <!-- LOADING SKELETON -->
                                <div *ngIf="loadingFailedOrders" class="card shadow-sm border-0">
                                    <div class="card-body p-4">
                                        <div class="placeholder-glow">
                                            <div class="placeholder col-4 mb-2"></div>
                                            <div class="placeholder col-7 mb-4"></div>
                                            <div class="placeholder col-12 mb-2"></div>
                                            <div class="placeholder col-10 mb-2"></div>
                                            <div class="placeholder col-8"></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="table-responsive" *ngIf="!loadingFailedOrders">
                                    <table class="table table-hover align-middle mb-0">
                                        <thead class="table-light">
                                            <tr class="small text-muted">
                                                <th style="min-width:160px;">Order</th>
                                                <th style="min-width:140px;">Pair</th>
                                                <th class="text-end" style="min-width:140px;">Amount</th>
                                                <th class="text-end" style="min-width:140px;">Remaining</th>
                                                <th class="text-end" style="min-width:120px;">Rate</th>
                                                <th style="min-width:120px;">Status</th>
                                                <th style="min-width:160px;">Created</th>
                                                <th class="text-end" style="min-width:160px;">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let order of failedOrders">
                                                <td>
                                                    <div class="d-flex align-items-center gap-2">
                                                        <span class="fw-semibold">
                                                            <a href="Javascript:void(0)" class="text-decoration-none"
                                                                (click)="viewOrder(order.id)">{{ shortId(order.id)
                                                                }}</a>
                                                        </span>

                                                        <button type="button" class="btn btn-link p-0 text-muted small"
                                                            (click)="copyToClipboard(order.id)"
                                                            title="Copy full Order ID" style="line-height:1;">
                                                            <i class="bi bi-clipboard"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                                <td class="fw-semibold">{{order.fromCurrency.code}} →
                                                    {{order.toCurrency.code}}</td>
                                                <td class="text-end">{{ order.originalAmount | smartAmount:order.fromCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.remainingAmount | smartAmount:order.toCurrency.symbol }}</td>
                                                <td class="text-end">{{ order.rate | smartAmount }} {{order.toCurrency.code +
                                                    "/"+order.fromCurrency.code}}</td>
                                                <td><span
                                                        [class]="getOrderStatusClass(order.status)">{{order.status}}</span>
                                                </td>
                                                <td class="text-muted small">{{order.createdAt | date:'medium'}}</td>
                                                <td class="text-end">
                                                    <button class="btn btn-outline-secondary btn-sm"
                                                        (click)="viewOrder(order.id)">View</button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="failedOrders.length === 0">
                                                <td colspan="8" class="text-center py-5 text-muted">
                                                    <div class="fw-semibold">No failed orders yet</div>
                                                    <div class="small">Your failed orders will appear here.</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <app-pagination *ngIf="failedOrdersMeta && failedOrdersMeta.totalRows > 0" [url]='url'
                                    [counts]='failedOrdersMeta' (refresh)="getOrder('Failed', $event)"></app-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-footer></app-footer>
    </main>
</div>